export default {
  mobileLanding: {
    media: {
      appPreview: "Vista previa animada de la app",
      leagues: "Pantalla de selección de ligas",
      trendFlow: "Flujo animado de tendencias",
      trendAnalysis: "Pantalla de análisis detallado de tendencias",
      myPicks: "Pantalla de Mis picks",
      checkout: "Pantalla de checkout",
    },
    sections: {
      research: {
        heading: "Pasa de investigar a apostar en segundos",
        body: "Linemate hace la investigación por ti, analizando tendencias y enfrentamientos para que pases de la información a la apuesta sin horas de búsqueda.",
      },
      leagues: {
        body: "Elige entre más de 18 ligas principales para explorar tendencias y jugadas adaptadas a los partidos y jugadores que más te importan.",
      },
      trends: {
        body: "Explora las tendencias con mejor rendimiento y elige una jugada respaldada por datos reales, rendimiento reciente y contexto relevante.",
      },
      analysis: {
        body: "Profundiza en cada jugada con desgloses claros de rendimiento, contexto situacional y las señales clave que impulsan la tendencia.",
      },
      odds: {
        body: "Encuentra las mejores cuotas disponibles entre operadores y obtén el mayor valor de cada apuesta.",
      },
      checkout: {
        body: "Completa tu apuesta en segundos con tu betslip llenado automáticamente en tu operador preferido.",
      },
    },
    cta: {
      titleLineOne: "Tu lugar",
      titleLineTwo: "para cada apuesta",
    },
  },
};